import SectionHeader from "@/components/SectionHeader";

const CATEGORIES = [
  { name: "Messaging", items: ["WhatsApp Business", "SMS Gateway", "Email", "Push Notifications"] },
  { name: "Payments", items: ["Razorpay", "Stripe", "PayU", "PhonePe", "Paytm", "UPI"] },
  { name: "Accounting", items: ["Tally", "Zoho Books", "QuickBooks", "GST Suvidha"] },
  { name: "Medical Devices", items: ["HL7", "DICOM", "PACS", "Lab Analyzers", "ECG Machines"] },
  { name: "Identity & Security", items: [/*"ABDM",*/ /*"Aadhaar OTP",*/ "Biometrics", "RFID"/*, "SSO (SAML/OIDC)"*/] },
  { name: "Communication", items: ["Zoom SDK", "Exotel"] },
  { name: "Cloud & Storage", items: ["AWS", "Azure", "GCP"/*, "MinIO On-prem"*/] },
  { name: "Government & Compliance", items: [/*"ABDM Health ID",*/ "ICMR Standards", "NABH Registries", "MCI Verify"] },
];

export default function Integrations() {
  return (
    <div data-testid="page-integrations">
      <section className="relative bg-[color:var(--paper-2)] overflow-hidden">
        <div className="absolute inset-0 bg-grid-light opacity-40" />
        <div className="relative container-x pt-4 md:pt-6 lg:pt-8 pb-12">
          <SectionHeader
            eyebrow="Integrations"
            title="Connects to everything"
            titleAccent="you already run."
            subtitle="Bring your own gateways, devices and identity providers. Or use the bundled best-in-class options."
          />
        </div>
      </section>

      <section className="section-y bg-white">
        <div className="container-x grid md:grid-cols-2 gap-6">
          {CATEGORIES.map((cat, i) => (
            <div
              key={cat.name}
              data-testid={`category-${i + 1}`}
              className="rounded-2xl border border-slate-200 p-6"
            >
              <div className="eyebrow">{cat.name}</div>
              <div className="mt-4 flex flex-wrap gap-2">
                {cat.items.map(it => (
                  <span
                    key={it}
                    className="px-3 py-1.5 rounded-full bg-slate-100 text-sm font-medium text-slate-700 hover:bg-[color:var(--brand-soft)] hover:text-[color:var(--brand-deep)] transition cursor-default"
                  >
                    {it}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
